import { render, staticRenderFns } from "./DashboardsTIView.vue?vue&type=template&id=30661e7f&scoped=true"
import script from "./DashboardsTIView.vue?vue&type=script&lang=js"
export * from "./DashboardsTIView.vue?vue&type=script&lang=js"
import style0 from "./DashboardsTIView.vue?vue&type=style&index=0&id=30661e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30661e7f",
  null
  
)

export default component.exports